import { DEVICE_CONFIGS } from '@src/constants/deviceConfigs';
import {
  DeviceType,
  DeviceWidgetContextValue,
} from '@src/types/devices/DeviceConfig.types';
import { createContext, ReactNode, useContext, useMemo } from 'react';

const DeviceWidgetContext = createContext<DeviceWidgetContextValue | undefined>(
  undefined,
);

interface DeviceWidgetProviderProps {
  children: ReactNode;
  deviceType: DeviceType;
  isUnitScope?: boolean;
}

export const DeviceWidgetProvider = ({
  children,
  deviceType,
  isUnitScope = true,
}: DeviceWidgetProviderProps) => {
  const value = useMemo<DeviceWidgetContextValue>(
    () => ({
      deviceType,
      config: DEVICE_CONFIGS[deviceType],
      isUnitScope,
    }),
    [deviceType, isUnitScope],
  );

  return (
    <DeviceWidgetContext.Provider value={value}>
      {children}
    </DeviceWidgetContext.Provider>
  );
};

DeviceWidgetProvider.displayName = 'DeviceWidgetProvider';

export const useDeviceWidget = (): DeviceWidgetContextValue => {
  const context = useContext(DeviceWidgetContext);
  if (context === undefined) {
    throw new Error(
      'useDeviceWidget must be used within a DeviceWidgetProvider',
    );
  }
  return context;
};
